import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';
import { APP_ROUTES } from '../../constants/app-routes';
import { getUserByCognitoId } from '../../core/users/action';

function StripeValidationPage() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const route = params.get('route');
  console.log('🚀 ~ file: StripeValidationPage.jsx:13 ~ StripeValidationPage ~ route', route);

  dispatch(getUserByCognitoId(user.cognito_id));

  return <Navigate to={route || APP_ROUTES.DASHBOARD} replace />;
}

export default StripeValidationPage;
